var map = {
	"./biology.svg": "adf2",
	"./chemistry.svg": "b027",
	"./english-language.svg": "89ad",
	"./history.svg": "bc9a",
	"./informatics.svg": "aac4",
	"./law-school.svg": "8634",
	"./literature.svg": "df35",
	"./mathematics.svg": "4f5d",
	"./mathematics_base.svg": "babe",
	"./olympiad-social-science.svg": "791f",
	"./olympiad.svg": "e4bb",
	"./physics.svg": "7b7c",
	"./russian-language.svg": "e2b6",
	"./social.svg": "7ec1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1f22";